var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"contact-proprietaire"},[_c('button',{staticClass:"btn_v2 vert",on:{"click":function($event){return _vm.proprietaireContact()}}},[_vm._v(_vm._s(_vm.$t('parcelle_obtenir_infos_proprio')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }